import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonNavBar } from './NavBar.definition';
import { chameleonTooltipV3 } from '../TooltipV3/TooltipV3.definition';
import { chameleonNavBarItem } from './NavBarItem/NavBarItem.definition';
import { chameleonSvg } from '../Svg';
import { chameleonButton } from '../Button/Button.definition';
import { chameleonPopoverV2 } from '../PopoverV2/PopoverV2.definition';
provideChameleonDesignSystem().register(chameleonNavBar(), chameleonNavBarItem(), chameleonTooltipV3(), chameleonSvg(), chameleonButton(), chameleonPopoverV2());
